import { TThunkAction } from '../../types/redux';
import { unsetMapOffer } from '../unsetMapOffer/unsetMapOffer';

export function closeOfferPreview(): TThunkAction {
  return dispatch => {
    dispatch(unsetMapOffer());
  };
}
